import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdArrowLeft, MdEmail } from 'react-icons/md';
import Countdown from 'react-countdown';
import axios from 'axios';
import { web_url } from '../../constant';


function ForgotPasswordPage1() {
    useEffect(() => {
        if (!localStorage.getItem('category')) {
            navigate('/loginas');
        }
    }, [])
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);

    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        navigate('/loginas')
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [forgotPasswordEmailDetails, setForgotPasswordEmailDetails] = useState(
        {
            email: '',
            tempPassword: '',
            time: ''
        }
    )

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
        }
    )

    const handleContinue = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let newErrors = {};
        newErrors.noEmail = !forgotPasswordEmailDetails.email;

        if ((forgotPasswordEmailDetails.email) && !emailRegex.test(forgotPasswordEmailDetails.email)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        localStorage.setItem('forgotpasswordemail', JSON.stringify(forgotPasswordEmailDetails))

        setIsLoading(true);
        setIsCountFinished(false);
        setEndTime(Date.now() + 60000);
        let category = (localStorage.getItem('category')).toUpperCase();
        axios.put(`${web_url}/api/auth/forgot-password/${forgotPasswordEmailDetails.email.toLowerCase()}?userRole=${category}`).then((resFor) => {
            setIsLoading(false);
            setOpen(true)
        }).catch((errFor) => {
            setIsLoading(false);

            if (errFor.response.data) {
                if (errFor.response.data) {
                    handleClickOpenError(errFor.response.data);
                } else if (errFor.response.data.message) {
                    handleClickOpenError(errFor.response.data.message);
                } else if (errFor.response.data.token) {
                    handleClickOpenError(errFor.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            } else {
                handleClickOpenError("An unknown error occured");
            }

        })
    }

    const renderer = ({ minutes, seconds }) => (
        <span>
            {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
    );

    const [isCountFinished, setIsCountFinished] = useState(true);
    const handleCompletion = () => {
        setIsCountFinished(true);
    };

    const [endTime, setEndTime] = useState(() => Date.now() + 10000);


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {

        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('not found with the provided email')) {
            setError(t('t272'));
        } else if (err.toLowerCase().includes('invalid credentials')) {
            setError(t('t100'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        localStorage.removeItem('/')
        navigate('/loginas')
    };

    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover bg-opacity-[10] h-screen w-screen flex flex-col  md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right  z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative z-10 h-auto  w-full'>
                <div className='flex items-center justify-start mt-[20px] xl:mt-[100px] 2xl:mt-[150px] xl:ml-[170px] 2xl:ml-[250px]' >
                    <MdArrowLeft className='text-[25px] md:text-[35px] lg:text-[33px] xl:text-[25px] 2xl:text-[22px]' />
                    <button className={`z-10 hover:underline font-bold ${i18n.language === "en" ? "text-[17px] md:text-[23px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]")}`} onClick={() => {
                        navigate('/loginas');
                    }}>
                        {t('t455')}
                    </button>
                </div>
                <div className='pl-[30px] pr-[30px] flex flex-col justify-start items-center h-full w-full absolute top-[10vh] md:top-[13vh] xl:top-[14vh] 2xl:top-[17vh]  '>
                    <div className='w-full md:w-[400px] lg:w-[500px] xl:w-[550px]  2xl:w-[500px] flex flex-col items-center justify-center'>
                        <img src="/images/forgot_pass.svg" className="h-[160px] md:h-[250px] xl:h-[250px] 2xl:h-[300px]" alt='logo' />
                        {
                            isLoading ?
                                <div className="items-center justify-center flex pt-[30px]">
                                    <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                </div>
                                :
                                <>
                                    <p className={`text-center font-bold ${i18n.language === "en" ? "text-[25px] md:text-[32px] lg:text-[40px] xl:text-[30px] 2xl:text-[41px]" : (i18n.language === "si" ? "text-[20px] md:text-[28px] lg:text-[38px] xl:text-[27px] 2xl:text-[37px]" : "text-[16px] md:text-[17px] lg:text-[25px] xl:text-[22px] 2xl:text-[27px]")} mt-[10px]`}>{t('t69')}</p>

                                    <p className={`text-black text-left mt-[20px] font-[500] ${i18n.language === "en" ? "text-[15px] md:text-[17px] lg:text-[19px] xl:text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[11px] md:text-[14px] lg:text-[17px] xl:text-[14px] 2xl:text-[18px]" : "text-[11px] md:text-[14px] lg:text-[17px] xl:text-[13px] 2xl:text-[16px]")}`}>{t('t74_1')}</p>

                                    <div className="w-full items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                        <MdEmail size="24px" color="#8189B0" />
                                        <input type="text" name="email"
                                            {...(isCountFinished ? {} : { readOnly: true })}
                                            className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t14')}
                                            onChange={(e) => {
                                                setForgotPasswordEmailDetails((prevState) => ({
                                                    ...prevState, email: e.target.value.toLowerCase()
                                                }))
                                            }}
                                        />
                                    </div>

                                    {errors.noEmail &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                                    }

                                    {errors.invalidEmail &&
                                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                                    }

                                    {isCountFinished &&
                                        <button onClick={handleContinue} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t70')}</button>
                                    }

                                    {!isCountFinished &&
                                        <div className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] text-center">
                                            {t('t73')} <Countdown
                                                date={endTime}
                                                renderer={renderer}
                                                onComplete={handleCompletion} />
                                        </div>
                                    }


                                    <p className="text-black text-[15px] text-center mt-[10px] font-bold">{t('t24')} <span onClick={() => (navigate('/loginas'))} className="text-[#FDC50C] hover:cursor-pointer hover:underline">{t('t25')}</span></p>

                                </>
                        }



                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {t('t273')}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t13')}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={openError}
                            onClose={handleCloseError}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogTitle
                                id="custom-dialog-title"
                                className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                            >
                                {t('t95')}
                            </DialogTitle>
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {error}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleCloseError}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPage1;